<script lang="ts">
import sectionComponent from '../components/global/section-component.vue';

export default {
  name: 'imprint-view',
  components: {
    sectionComponent
  },
  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>

<template>
  <sectionComponent :class="$props.title">
    <h1 class="title">{{ $props.title }}</h1>
    <div class="content">
      <h2 class="wp-block-heading">Angaben gemäß § 5 TMG</h2>

      <p>
        Thomas Strotmann<br />Fahrschule Strotmann<br />Amselweg 3B<br />49186
        Bad Iburg
      </p>

      <h2 class="wp-block-heading">
        Zuständige Behörde für Genehmigung und Überwachung:
      </h2>

      <p>Landkreis Osnabrück</p>

      <p>
        Am Schölerberg 1<br />49082 Osnabrück<br />Telefon (05 41) 5 01-0<br />Telefax
        (05 41) 5 01-44 02
      </p>

      <h2 class="wp-block-heading">Kontakt</h2>

      <p>
        Telefon:&nbsp;05403/7269741<br />Telefax: 05403/7269740<br />E-Mail:&nbsp;<a>
          info@fahrschule-strotmann.de
        </a>
      </p>

      <h2 class="wp-block-heading">Umsatzsteuer-ID</h2>

      <p>
        Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />DE
        262 658 979
      </p>

      <h2 class="wp-block-heading">Redaktionell verantwortlich</h2>

      <p>Thomas Strotmann, Amselweg 3B, 49186 Bad Iburg</p>

      <h2 class="wp-block-heading">EU-Streitschlichtung</h2>

      <p>
        Die Europäische Kommission stellt eine Plattform zur
        Online-Streitbeilegung (OS) bereit:&nbsp;<a
          href="https://ec.europa.eu/consumers/odr/"
          target="_blank"
          rel="noreferrer noopener"
        >
          https://ec.europa.eu/consumers/odr/ </a
        >.<br />Unsere E-Mail-Adresse finden Sie oben im Impressum.
      </p>

      <h2 class="wp-block-heading">
        Verbraucher&shy;streit&shy;beilegung/Universal&shy;schlichtungs&shy;stelle
      </h2>

      <p>
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
        vor einer Verbraucherschlichtungsstelle teilzunehmen.
      </p>
    </div>
  </sectionComponent>
</template>

<style lang="scss">
@use 'sass:map';
@import '@/styles/variables';
@import '@/styles/colors';
@import '@/styles/mixins';

.title {
  display: flex;
  align-items: center;
  position: relative;
  color: map.get($colors, 'white');

  &::before {
    content: '';
    width: 3rem;
    height: 0.125rem;
    margin-right: 0.5rem;
    background-color: map.get($colors, 'white');
  }
}

.content {
  .wp-block-heading {
    span {
      strong {
        font-size: map.get($heading-font-sizes, 'h2');
        color: map.get($colors, 'secondary');
      }
    }
  }

  .wp-block-group {
    > * {
      display: flex;

      p {
        display: flex;
        margin: 0 1rem 0 0;

        &:last-child {
          margin-right: 0;
        }
      }

      a {
        display: inline-flex;
        align-items: center;

        &:hover::before {
          background-color: map.get($colors, 'primary');
        }

        &::before {
          content: '';
          display: block;
          width: 1.5rem;
          height: 1.5rem;
          margin-right: 0.5rem;
          mask-size: contain;
          mask-repeat: no-repeat;
          mask-position: center;
          background-color: map.get($colors, 'white');
          transition: $transition-base;
        }

        &.phone::before {
          mask-image: url('@/assets/icons/phone.svg');
        }

        &.mail::before {
          mask-image: url('@/assets/icons/mail.svg');
        }
      }

      @include media-breakpoint-down(md) {
        flex-direction: column;

        p {
          margin: 0 0 1rem;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>
